export class NotificationConfig {
    public id: string;
    public message: string;
    public type: string;
    public autoCloseTimeout: number;
}
